import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { provideRouter, withEnabledBlockingInitialNavigation, RouterModule } from '@angular/router';
import { CoreEffects } from '@next/core-lib';
import { provideAgrCore } from '@next/core-lib/app';
import { I18nBrowserEffects } from '@next/core-lib/browser';
import { I18nEffects } from '@next/core-lib/i18n';
import { NavigationEffects } from '@next/core-lib/navigation';
import { provideAgrRouterStore } from '@next/core-lib/router-store';
import { provideAgrSettings } from '@next/core-lib/settings';
import { SiteEffects } from '@next/core-lib/site';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';

import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';

import { AppWizardModule } from './app-wizard/app-wizard.module';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { BusinessPartnerBackofficeModule } from './business-partner-backoffice/business-partner-backoffice.module';
import { DevAuthModule } from './dev-auth/dev-auth.module';
import { DevTokensModule } from './dev-tokens/dev-tokens.module';
import { InformationModule } from './information/information.module';
import { LabresultModule } from './labresults/labresult.module';
import { ExternalLabResultsTokenInterceptor } from './labresults/services/external-lab-results-token.interceptor';
import { ProfileModule } from './profile/profile.module';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    RouterModule,
    SharedModule,
    InformationModule,
    LabresultModule,
    BusinessPartnerBackofficeModule,
    ProfileModule,
    AppWizardModule,
    DevTokensModule,
    DevAuthModule,
    AgrWrapperSiteSidenavModule,
    MatIconModule,
    MatListModule,
  ],
  providers: [
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideStore({}),
    provideAgrRouterStore(),
    provideAgrCore(),
    provideAgrSettings(),
    provideEffects([CoreEffects, I18nEffects, I18nBrowserEffects, SiteEffects, NavigationEffects]),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ExternalLabResultsTokenInterceptor,
      multi: true,
    },
  ],
})
export class AppModule {}
